import React from 'react';
import PropTypes from 'prop-types';

import PDPUpSellFlyOutUI from './PDPUpSellFlyOutUI';

const PDPUpSellFlyOut = ({
  top,
  name,
  price,
  hidePrice,
  salePrice,
  optionPrice,
  promotion,
  imageUrl,
  description,
  closeFlyOut,
  totalReviews,
  averageRating,
}) => (
  <PDPUpSellFlyOutUI
    top={top}
    name={name}
    price={price}
    imageUrl={imageUrl}
    hidePrice={hidePrice}
    salePrice={salePrice}
    optionPrice={optionPrice}
    promotion={promotion}
    closeFlyOut={closeFlyOut}
    description={description}
    totalReviews={totalReviews}
    averageRating={averageRating}
  />
);

PDPUpSellFlyOut.propTypes = {
  top: PropTypes.number,
  name: PropTypes.string,
  price: PropTypes.object,
  optionPrice: PropTypes.number,
  salePrice: PropTypes.number,
  hidePrice: PropTypes.bool,
  imageUrl: PropTypes.string,
  description: PropTypes.string,
  totalReviews: PropTypes.number,
  averageRating: PropTypes.number,
  promotion: PropTypes.shape({
    tiers: PropTypes.arrayOf(
      PropTypes.shape({
        min_cart: PropTypes.number,
        discount: PropTypes.number,
      })
    ),
  }),
  closeFlyOut: PropTypes.func,
};

export default PDPUpSellFlyOut;
